/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from "react";
import "./AddParent.scss";
import { useDispatch } from "react-redux";
import { addCustomerInCompany, fetchCustomer } from "../../store/slices/thunk";
import { toast, ToastContainer } from "react-toastify";

interface Parent {
  id: number | string;
}

interface AddParentProps {
  onClose: () => void;
  companyId: string | undefined;
}

const AddParent: React.FC<AddParentProps> = ({ onClose, companyId }) => {
  const dispatch: any = useDispatch();
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState<any[]>([]);
  const [allParents, setAllParents] = useState<any[]>([]);

  useEffect(() => {
    const getCustomers = async () => {
      try {
        const response = await dispatch(fetchCustomer(1, 100, "", "", ""));
        if (response?.isSuccess && response?.data?.data?.length > 0) {
          debugger
          const formatted = response.data.data.map((item: any) => ({
            id: item?._id,
            name: item?.name,
            email: item?.email,
            isAdded: item?.company?.companyId === companyId, 
          }));

          setAllParents(formatted);

       
          const alreadySelected = formatted
            .filter((p: any) => p.isAdded)
            .map((p: any) => p.id);
          setSelected(alreadySelected);
        }
      } catch (error) {
        console.error("Error fetching customers:", error);
      }
    };

    getCustomers();
  }, [dispatch, companyId]);

  const filtered = allParents.filter((p) =>
    p.name.toLowerCase().includes(search.toLowerCase())
  );

  const toggleSelect = (e: React.ChangeEvent<HTMLInputElement>, id: any) => {
    if (e.target.checked) {
      setSelected((prev) => [...prev, id]);
    } else {
      setSelected((prev) => prev.filter((pid) => pid !== id));
    }
  };

  const handleSelectCustomer = async () => {
    try {
      // let data:any = {
      //   companyId:companyId,
      //   customerIds:selected,
      // }
      let response = await dispatch(addCustomerInCompany(companyId, selected));
      if (response && response.data && response.isSuccess) {
        toast.success("Parents assign successfully");
        onClose();
      } else {
        toast.error("Error");
      }
    } catch (error) {
      toast.error("Error");
    }
  };
  return (
    <>
      <div className="modal-overlay">
        <ToastContainer />
        <div className="modal-container">
          {/* Header */}
          <div className="modal-header">
            <h2>Select Parents</h2>
            <button className="close-btn" onClick={onClose}>
              ✖
            </button>
          </div>

          {/* Search Bar */}
          <input
            type="text"
            placeholder="Search parent..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="search-bar"
          />

          {/* Parent List */}
          <div className="parent-list">
            {filtered.length > 0 ? (
              filtered.map((parent) => (
                <div key={parent.id} className="parent-item">
                  <label>
                    <input
                      type="checkbox"
                      checked={selected.includes(parent.id)}
                      // checked={selected.includes(parent.id)}
                      onChange={(e) => toggleSelect(e, parent.id)}
                    />
                    <span className="parent-name">{parent.name}</span> —{" "}
                    <span className="parent-email">{parent.email}</span>
                  </label>
                </div>
              ))
            ) : (
              <p className="no-results">No parents found</p>
            )}
          </div>

          {/* Footer */}
          <div className="modal-footer">
            <button className="btn btn-gray" onClick={onClose}>
              Cancel
            </button>
            <button
              className="btn btn-blue"
              onClick={() => {
                handleSelectCustomer();
              }}
              disabled={selected.length === 0}
            >
              Add Selected
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddParent;
